import { connect } from 'react-redux';

import CsvRequests from '../../../components/navigation/csv/CsvRequests';
import { getCSVExecuteDataFromJobIds } from '../../../reducers/analyticsApp';
import { cancelRequest } from '../../../api/execute';

const mapStateToProps = (state) => {
  const executeCsvData = getCSVExecuteDataFromJobIds(state);

  return {
    requests: executeCsvData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CsvRequests);
